import * as React from 'react';

import InputRadio from 'components/inputs/input-radio/InputRadio';
import Link from 'libs/router/Link';

import { t } from 'utils/language';

import './shipping-address-selection.scss';

import type { ShippingAddress, TextEntry } from 'types';
import type { SyntheticEvent } from 'react';

type Props = {
  address: ShippingAddress,
  selectedAddressId: number | undefined | null,
  index: number,
  onAddressChange: (id: number) => void,
  onEditAddress: (address: ShippingAddress) => void
};

class ShippingStepSelectionAddress extends React.PureComponent<Props> {
  handleAddressChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { onAddressChange } = this.props;

    onAddressChange(Number(event.target.value));
  };

  handleEditAddress = (event: SyntheticEvent<TextEntry>) => {
    event.preventDefault();

    const { onEditAddress, address } = this.props;

    onEditAddress(address);
  };

  // TODO move this into utils
  getAddress(address: ShippingAddress) {
    const parts = [
      address.address1,
      address.city
    ];

    if (address.stateProvinceRegion) {
      parts.push(address.stateProvinceRegion);
    }

    parts.push(address.zip);
    parts.push(address.country);

    return parts.join(', ');
  }

  render() {
    const {
      address,
      selectedAddressId,
      index
    } = this.props;

    const addressLabel = (
      <span>
        <strong>{address.recipient}</strong> {this.getAddress(address)}
      </span>
    );

    return (
      <div className="shipping-address-selection__address-container">
        <InputRadio
          name="cancellation-feedback"
          value={String(address.id)}
          id={`shipping-address-${address.id || index}`}
          checked={address.id === selectedAddressId}
          label={addressLabel}
          onChange={this.handleAddressChanged}
        />
        &nbsp;&nbsp;
        <Link
          color="secondary"
          onClick={this.handleEditAddress}
          className="shipping-address-selection__link"
        >
          {t('shipping_address.label_edit_address')}
        </Link>
      </div>
    );
  }
}

export default ShippingStepSelectionAddress;
